import { useStore } from "..";
export const useProjectOnboarding = () => useStore(({ projectOnboarding }) => projectOnboarding);
